import { Icon } from './Icon';
import type { IconProps } from '../../types';

export { Icon };

export const MessageSquare = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </Icon>
);

export const Clock = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </Icon>
);

export const FileText = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </Icon>
);

export const TrendingUp = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </Icon>
);

export const Plug = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="M12 22v-5" />
    <path d="M9 8V2" />
    <path d="M15 8V2" />
    <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" />
  </Icon>
);

export const CreditCard = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </Icon>
);

export const Key = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <circle cx="7.5" cy="15.5" r="5.5" />
    <path d="m21 2-9.6 9.6" />
    <path d="m15.5 7.5 3 3L22 7l-3-3" />
  </Icon>
);

export const Eye = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </Icon>
);

export const Target = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </Icon>
);

export const Handshake = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="m11 17 2 2a1 1 0 1 0 3-3" />
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
    <path d="m21 3 1 11h-2" />
    <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
    <path d="M3 4h8" />
  </Icon>
);

export const Check = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <polyline points="20 6 9 17 4 12" />
  </Icon>
);

export const X = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </Icon>
);

export const ArrowDown = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <polyline points="19 12 12 19 5 12" />
  </Icon>
);

export const ChevronLeft = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <polyline points="15 18 9 12 15 6" />
  </Icon>
);

export const ChevronRight = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <polyline points="9 18 15 12 9 6" />
  </Icon>
);

export const Mail = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <polyline points="22 7 12 13 2 7" />
  </Icon>
);

export const CalendarDays = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="8" y1="14" x2="8" y2="14.01" />
    <line x1="12" y1="14" x2="12" y2="14.01" />
    <line x1="16" y1="14" x2="16" y2="14.01" />
    <line x1="8" y1="18" x2="8" y2="18.01" />
    <line x1="12" y1="18" x2="12" y2="18.01" />
    <line x1="16" y1="18" x2="16" y2="18.01" />
  </Icon>
);

export const ClipboardList = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <path d="M12 11h4" />
    <path d="M12 16h4" />
    <path d="M8 11h.01" />
    <path d="M8 16h.01" />
  </Icon>
);

export const DollarSign = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </Icon>
);

export const BarChart3 = ({ size, strokeWidth }: IconProps) => (
  <Icon size={size} strokeWidth={strokeWidth}>
    <path d="M18 20V10" />
    <path d="M12 20V4" />
    <path d="M6 20v-6" />
  </Icon>
);
